<div>
    <div class="row">
        <div class="col-12">    
            ({{isDeId(selectedRow?.employeeName)}} | {{selectedRow?.adminGroup}} | {{isDeId(selectedRow?.lanId)}})    
        </div>
    </div>
    <div class="row m-2 variance-modal-links" style="padding-top:5px">
        <div class="col-auto">
            <p-button label="Follow Up Status" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(1)" [style]="{'margin-right': '5px'}"></p-button>
        </div>
        <div class="col-auto">
            <div>
                <p-button label="Documents" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(2)"></p-button> 
                <span class="badge badge-light"> {{ totalCount }} </span>
            </div> 
        </div>
       
    </div>
      <div class="row">
        <div class="col-auto" *ngIf="documentService.tab===2">
          <app-browse-documents [record]="selectedRow" (valueChange)='updateDocumentCount($event)' ></app-browse-documents>
        </div>
        <div class="col-auto" *ngIf="documentService.tab===3">
            <app-upload-document [record]="selectedRow" (updateValue)='updateCount($event)'></app-upload-document>
        </div>
      </div>
     
      <div class="row m-2 p-2" [hidden]="documentService.tab!==1">
        <div class="row w-100">
                <div class="col-md-12 text-center my-2">
                <!-- <p-message [(value)]="msgs"></p-message> -->
                    <!-- <p-message *ngIf="msg!=''" severity="info" [text]="msg"></p-message> -->
                </div>
                <div class="col-md-6">
                    <div *ngIf="this.selectedRow!==null && this.selectedRow!==undefined" style="margin-left: 32px;" class="form-group">
                        <h4  class="maap-title-2" >Change Follow Up Status</h4>
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select 
                                [options]="followups"
                                [(ngModel)]="followUp" 
                                [filter]="true" 
                                placeholder="Update Follow Up"
                                [styleClass]="'change-status-dropdown w-100'">
                                <ng-template let-item pTemplate="selectedItem">
                                    <span style="vertical-align:middle; margin-left: .5em">{{item.label}}</span>
                                </ng-template>
                                <ng-template let-followup pTemplate="item">
                                    <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                                        <div style="float:center;margin-top:4px">
                                            {{followup.label}}
                                        </div>
                                    </div>
                                </ng-template>
                            </p-select>
                            <label for="followup">Follow Up Status</label>
                        </p-floatlabel>
                    </div>
                    <ul class="maap-modal-list">
                        <li> <span class="maap-title">User Name:</span><span class="maap-title-value">{{isDeId(selectedRow?.employeeName)}}</span></li>
                        <li> <span class="maap-title">Role:</span><span class="maap-title-value">{{selectedRow?.adminGroup}}</span></li>
                        <li> <span class="maap-title">User ID:</span><span class="maap-title-value">{{isDeId(selectedRow?.lanId)}}</span> </li>
                        <li> <span class="maap-title">Area:</span><span class="maap-title-value">{{selectedRow?.locationGroupingString}}</span></li>
                        <li> <span class="maap-title">Follow Up:</span><span class="maap-title-value">{{selectedRow?.followUp}}</span></li>
                        <!-- <li> <span class="maap-title">ToTal Var:</span><span class="maap-title-value"> {{selectedRow.highRisk+selectedRow.highModRisk+selectedRow.lowRisk+selectedRow.modRisk+selectedRow.modRisk}}</span></li> -->
                        <li> <span class="maap-title">Date/Time:</span><span class="maap-title-value">{{selectedRow?.createdAt|date : 'MM/dd/yyyy | HH:mm'}}</span> </li>
                    </ul>
    
                    <!-- <hr> -->
                    <!-- <ul class="maap-modal-list">
                        <li> <span class="maap-title">Assay Number :</span><span class="maap-title-value">
                               </span> </li>
                        <li><span class="maap-title">Process Date:</span><span class="maap-title-value"> </span> </li>
                        <li> <span class="maap-title">Assay Risk Score:</span><span class="maap-title-value"> </span> </li>
    
    
                    </ul> -->
    
    
                </div>
                <div class="col-md-6">
                    <div *ngIf="this.selectedRow!==null && this.selectedRow!==undefined" class="form-group comment-editor-group">
                        <h4  class="maap-title-2">Comment</h4>
                        <app-mention-editor [(value)]="comment" [(taggedUsers)]="taggedUsers"
                          [users]="userMentions" [minRows]="8"></app-mention-editor>
                    </div>
    
                    <h4  class="maap-title-2">History</h4>
    
                    <div [ngClass]="[getHistoryBlurClass(), 'history-content']">
                        <div *ngFor="let comment of comments">
                            <p>{{comment["createdAt"]| date : 'MM/dd/yyyy | HH:mm'}} - {{comment['followUp']}} </p>
                            <p>{{comment["comment"]}}</p>
                            <p class="font-weight-bold" style="text-align:right">By {{comment["authorName"]}}</p>
                            <br>
                        </div>
                        <div>
                            <p>
                                <!-- Case marked as open because no other Follow Up history associated with this admin. -->
                                {{createdAt| date : 'MM/dd/yyyy | HH:mm'}} - {{ originalFollowup }}
                            </p>
                            <p class="font-weight-bold" style="text-align:right">Assigned by Software</p>
                          </div>
                    </div>
    
                </div>
                <div class="col-md-12 mt-2">
                    <p-footer class="mt-3 w-100">
                        <p class="font-weight-bold float-left">{{lockMessage}}</p> 
                        <p-button label="Cancel" styleClass="p-button-sm float-right" (click)="closeDialog()"></p-button>
                        <p-button label="Submit" icon="pi pi-check" styleClass="p-button-sm float-right" (click)="submit()" [disabled]="isLocked" [loading]="isSubmitting"></p-button>
                        <p-button label="Share" icon="pi pi-share-alt" styleClass="p-button-sm float-right" (click)="shareAdminFollowUp()"></p-button>
                        <p-button label="Generate Investigative Summary Report " styleClass="p-button-sm float-right" (click)="OpenGSR()"></p-button>
                    </p-footer>
                </div>
            </div>
    
    </div>

   
    
</div>
